import { Link } from 'react-router-dom'

const footerLinks = {
  units: [
    { href: '/music', label: 'KHC Music' },
    { href: '/labs', label: 'KHC Labs' },
    { href: '/consulting', label: 'KHC Consulting' },
  ],
  apps: [
    { href: '/labs/apps/voxnote', label: 'VoxNote' },
  ],
}

export function Footer() {
  return (
    <footer className="border-t bg-muted/30">
      <div className="container mx-auto px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-3">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="text-xl font-bold">
              KHC One
            </Link>
            <p className="text-sm text-muted-foreground">
              Music · Technology · Consulting
            </p>
          </div>

          {/* Units */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold">Units</h4>
            <ul className="space-y-2">
              {footerLinks.units.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Apps */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold">Apps</h4>
            <ul className="space-y-2">
              {footerLinks.apps.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 flex flex-col items-center justify-center gap-4 border-t pt-8">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} KHC One. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
